import React, { useState } from 'react';
import axios from 'axios';
import API_URL from '../config';

function AddOrderModal({ onClose, onSuccess, isCustomer, customerId }) {
  const [quantity, setQuantity] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const finalCustomerId = isCustomer ? customerId : document.getElementById('customerSelect')?.value;
      await axios.post(`${API_URL}/add-order`, {
        customer_id: finalCustomerId,
        ordered_quantity: parseFloat(quantity)
      });
      onSuccess();
      onClose();
    } catch (err) {
      alert('Error placing order: ' + (err.response?.data?.error || err.message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h2>Place New Order</h2>
        <form onSubmit={handleSubmit}>
          <input type="number" step="0.01" placeholder="Quantity (kg)" value={quantity} onChange={(e) => setQuantity(e.target.value)} required />
          <div className="modal-buttons">
            <button type="button" onClick={onClose}>Cancel</button>
            <button type="submit" disabled={loading}>{loading ? 'Placing...' : 'Place Order'}</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddOrderModal;